import './css/style.scss'
import resizeLogo from '../microsite_allgemein/js/logoResizer'
import * as breakpoints from '../microsite_allgemein/css/breakpoints.scss?module'
import './js/startseite'
import './js/article'
import './js/category'
import './js/curious'
import './js/termine'

document.addEventListener('DOMContentLoaded', async () => {
    resizeLogo(+breakpoints.sm.slice(0, -2), 200)
})